/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading never becomes a grid`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一直加载，没有出现网格`)
};

/**
* | output |
* | --- |
* | "Loading never becomes a grid" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_1_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_1_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_1_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_1_0 as "gc.search_guides.gridcraft_online.sections.3.table.rows.1.0" }